module.exports = __webpack_public_path__ + "static/media/PT.9e9f9155.svg";